import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import { updateTask } from 'actions/asyncActions';
import { omit, path } from 'ramda';

import TaskModal from './TaskModal';
import { strToDate } from 'mappers/commonMapper';

const getAlarmDate = path(['alarm', 'date']);
const getAlarmTime = path(['alarm', 'time']);

const getInitialValues = (values) => omit(['dateFrom', 'dateTo'], {
    ...values,
    date: {
        from: strToDate(values.dateFrom),
        to: strToDate(values.dateTo)
    }
});

const isAlarm = (initialValues) => !!getAlarmDate(initialValues) || !!getAlarmTime(initialValues);

@withAsyncActions({
    updateTask: updateTask
        .withSuccessHandler(props => props.close())
        .withOptions({ autoReset: true })
})
export default class EditTaskModal extends Component {
    render() {
        const { modal, updateTask: { meta }, params, updateTask }  = this.props;
        const initialValues = getInitialValues(params);

        return (
            <TaskModal
                modal={modal}
                alarm={isAlarm(initialValues)}
                titleTranslate="calendar.edit_task"
                initialValues={initialValues}
                meta={meta}
                formAction={updateTask} />
        );
    }
}
